import { render, staticRenderFns } from "./SolutionsProductsPage.vue?vue&type=template&id=0348280f&scoped=true"
import script from "./SolutionsProductsPage.js?vue&type=script&lang=js&external"
export * from "./SolutionsProductsPage.js?vue&type=script&lang=js&external"
import style0 from "./SolutionsProductsPage.scss?vue&type=style&index=0&id=0348280f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0348280f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default,HotImage: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Image/Image.vue').default,HotTag: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Tag/Tag.vue').default,HotButton: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Button/Button.vue').default})
